import type { DocumentListTableProps } from "./documentTableTypes";
function defaultOption<T>(value: T | undefined, fallback: T): T {
  return value === undefined ? fallback : value;
}
export function documentTableOptions(props: DocumentListTableProps) {
  return {
    ...props,
    folders: defaultOption(props.folders, []),
    showCheckbox: defaultOption(props.showCheckbox, true),
    requestedShowVersion: defaultOption(props.showVersion, true),
    requestedShowDateCreated: defaultOption(props.showDateCreated, true),
    requestedShowStatus: defaultOption(props.showStatus, true),
    showUser: defaultOption(props.showUser, true),
    requestedShowTags: defaultOption(props.showTags, true),
    requestedShowParent: defaultOption(props.showParent, false),
    showActions: defaultOption(props.showActions, true),
    showDeleteAction: defaultOption(props.showDeleteAction, true),
    showDownloadAction: defaultOption(props.showDownloadAction, true),
    isRestore: defaultOption(props.isRestore, false),
    isRefreshing: defaultOption(props.isRefreshing, false),
    hasMore: defaultOption(props.hasMore, false),
    isLoadingMore: defaultOption(props.isLoadingMore, false),
    paginationPageSize: props.pageSize,
    disableChildModal: defaultOption(props.disableChildModal, false),
    hideBulkActionBar: defaultOption(props.hideBulkActionBar, false),
    isSelectionPending: defaultOption(props.isSelectionPending, false),
    selectedFolderIds: defaultOption(props.selectedFolderIds, []),
    canMoveToTrash: defaultOption(props.canMoveToTrash, true),
    activeMoveProp: props.activeMove,
  };
}
